// extracted by mini-css-extract-plugin
module.exports = {"button":"search-button_button__2ncit"};